module.exports = __webpack_public_path__ + "static/media/auth-success.71f401a9.svg";